module.exports = __webpack_public_path__ + "static/media/logobb.8e41949d.png";